// import { createAuthPlugin } from '@industronics/fids-utils';
import axios from 'axios';
import { createAuthPlugin } from './react-auth-plugin';

const dcmmApi = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true, // so /auth/token/refresh can use the cookie
});

export const auth = createAuthPlugin({
    authBaseURL: process.env.REACT_APP_AUTH_API_URL!,  
    loginURL: process.env.REACT_APP_AUTH_URL,
    devStaticAccessToken: process.env.REACT_APP_ACCESS_TOKEN
});

auth.attachAuthInterceptor(dcmmApi);
auth.attachTaggingInterceptor(dcmmApi);

export default dcmmApi;
